import { takeEvery } from "@redux-saga/core/effects";

import { handleGetZapierAuthURL } from "./handleGetZapierAuthURLSaga";

import { handleGetHubspotAuthURL } from "./handleHubspotAuthUrlSaga";
import { handleGetHubspotStatus } from "./handleGetHubspotStatusSaga";
import { updateHubspotPropertySaga } from "./updateHubspotPropertySaga";
import { getHubspotTablesSaga } from "./getHubspotTables";
import { handleGetGoogleSheetsAuthURL } from "./handleGoogleSheetsAuthUrlSaga";
import { getGoogleSheetsSaga } from "./getGoogleSheetsSaga";
import { updateGoogleSheetsConfigSaga } from "./updateGoogleSheetsConfig";
import { handleDisconnectIntegration } from "./disconnectIntegrationSaga";
import { getIntegrationStatusesSaga } from "./getIntegrationStatusesSaga";
import { getGoogleSheetWorksheetsSaga } from "./getGoogleSheetWorksheetSaga";
import { handleGetHubspotData } from "./handleGetHubspotDataSaga";
import {
    IntegrationActionTypes,
    DisconnectIntegrationRequestActionType,
    GetGoogleSheetsAuthURLRequestActionType,
    GetGoogleSheetsRequestActionType,
    GetGoogleSheetWorksheetsRequestActionType,
    GetHubspotAuthURLRequestActionType,
    GetHubspotDataRequestActionType,
    GetHubspotStatusRequestActionType,
    GetHubspotTablesRequestActionType,
    GetIntegrationStatusesRequestActionType,
    GetZapierAuthURLRequestActionType,
    GetZapierTokensRequestActionType,
    GetZapierZapsRequestActionType,
    DisconnectZapierRequestActionType,
    UpdateHubspotPropertyRequestActionType,
    GetMailchimpRequestActionType,
    GetMailchimpAuthURLRequestActionType,
    GetMailchimpSelectedFieldsRequestActionType,
} from "../types";
import { getMailchimpListsSaga } from "./getMailchimpListsSaga";
import { updateMailchimpConfigSaga } from "./updateMailchimpConfigSaga";
import { getMailchimpSelectedFieldsSaga } from "./getMailchimpSelectedFieldsSaga";
import { handleGetMailchimpAuthURL } from "./handleMailchimpAuthUrlSaga";
import { handleDisconnectZapier } from "./disconnectZapierSaga";
import { handleGetZapierZaps } from "./getZapierZapsSaga";
import { handleGetZapierTokens } from "./zapierTokensSaga";

export default function* integrationsSaga() {
    yield takeEvery<GetZapierAuthURLRequestActionType>(
        IntegrationActionTypes.GET_ZAPIER_AUTH_URL_REQUEST,
        handleGetZapierAuthURL,
    );
    yield takeEvery<GetZapierTokensRequestActionType>(
        IntegrationActionTypes.GET_ZAPIER_TOKENS_REQUEST,
        handleGetZapierTokens,
    );

    yield takeEvery<GetZapierZapsRequestActionType>(
        IntegrationActionTypes.GET_ZAPIER_ZAPS_REQUEST,
        handleGetZapierZaps,
    );

    yield takeEvery<DisconnectZapierRequestActionType>(
        IntegrationActionTypes.DISCONNECT_ZAPIER_REQUEST,
        handleDisconnectZapier,
    );
    yield takeEvery<GetHubspotAuthURLRequestActionType>(
        IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST,
        handleGetHubspotAuthURL,
    );
    yield takeEvery<GetHubspotDataRequestActionType>(
        IntegrationActionTypes.GET_HUBSPOT_DATA_REQUEST,
        handleGetHubspotData,
    );
    yield takeEvery<GetHubspotStatusRequestActionType>(
        IntegrationActionTypes.GET_HUBSPOT_STATUS_REQUEST,
        handleGetHubspotStatus,
    );
    yield takeEvery<UpdateHubspotPropertyRequestActionType>(
        IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST,
        updateHubspotPropertySaga,
    );
    yield takeEvery<GetHubspotTablesRequestActionType>(
        IntegrationActionTypes.GET_HUBSPOT_TABLES_REQUEST,
        getHubspotTablesSaga,
    );

    yield takeEvery<GetGoogleSheetsAuthURLRequestActionType>(
        IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_REQUEST,
        handleGetGoogleSheetsAuthURL,
    );
    yield takeEvery<GetGoogleSheetsRequestActionType>(
        IntegrationActionTypes.GET_GOOGLESHEETS_REQUEST,
        getGoogleSheetsSaga,
    );
    yield takeEvery(IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST, updateGoogleSheetsConfigSaga);
    yield takeEvery<GetGoogleSheetWorksheetsRequestActionType>(
        IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_REQUEST,
        getGoogleSheetWorksheetsSaga,
    );
    yield takeEvery<DisconnectIntegrationRequestActionType>(
        IntegrationActionTypes.DISCONNECT_INTEGRATION_REQUEST,
        handleDisconnectIntegration,
    );
    yield takeEvery<GetIntegrationStatusesRequestActionType>(
        IntegrationActionTypes.GET_INTEGRATION_STATUSES_REQUEST,
        getIntegrationStatusesSaga,
    );
    yield takeEvery<GetMailchimpRequestActionType>(IntegrationActionTypes.GET_MAILCHIMP_REQUEST, getMailchimpListsSaga);

    yield takeEvery(IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_REQUEST, updateMailchimpConfigSaga);

    yield takeEvery<GetMailchimpSelectedFieldsRequestActionType>(
        IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_REQUEST,
        getMailchimpSelectedFieldsSaga,
    );

    yield takeEvery<GetMailchimpAuthURLRequestActionType>(
        IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_REQUEST,
        handleGetMailchimpAuthURL,
    );
}
